import { RadioButtons as AntdRadioButtons } from "@empglabs/backoffice-ui-kit"
import { forwardRef } from "react"

const RadioButtons = forwardRef((props, ref) => {
  return <AntdRadioButtons ref={ref} {...props} />
})

export default RadioButtons
